import React from 'react';
import styled from 'styled-components';
import Column from '../../column';
import Highlight from './highlight';
import Grid from './grid';

const Highlights = ({
  // id,
  highlights,
  offset,
}) => ((highlights || []).length === 0 ? null : (
  <Column justify="center" offset={offset}>
    <Grid $columns={highlights.length}>
      {highlights.map((highlight) => (
        <Highlight key={highlight.id} {...highlight} />
      ))}
    </Grid>
  </Column>
));

export default styled(Highlights)``;
